
import { defineComponent, ref } from 'vue'

export default defineComponent({
    props: {
        title: {
            type: String,
            required: true,
            default: "",
        },
        subTitle: {
            type: String,
            required: false,
            default: "",
        }
    },
    setup( props ) {
        /*const title = ref(props.title );
        
        return {
            title
        }
        */
        
    },
})
